import { QueryClientProvider, Hydrate } from '@tanstack/react-query';
import * as React from 'react';

var ThemeContext = /*#__PURE__*/React.createContext(null);

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme !== null && theme !== void 0 ? theme : null
  }, children);
};

var Context = /*#__PURE__*/React.createContext(undefined);

// we create a custom query context so that all queries can use this and not share context with other react-query
var QueryClientContext = /*#__PURE__*/React.createContext(undefined);
function LivepeerConfig(_ref) {
  var children = _ref.children,
    client = _ref.client,
    theme = _ref.theme,
    dehydratedState = _ref.dehydratedState;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: client
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    context: QueryClientContext,
    client: client.queryClient
  }, /*#__PURE__*/React.createElement(Hydrate, {
    options: {
      context: QueryClientContext
    },
    state: dehydratedState !== null && dehydratedState !== void 0 ? dehydratedState : undefined
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, children))));
}
function useClient() {
  var client = React.useContext(Context);
  if (!client) throw new Error(['`useClient` must be used within `LivepeerConfig`.'].join('\n'));
  return client;
}

export { Context as C, LivepeerConfig as L, QueryClientContext as Q, ThemeProvider as T, ThemeContext as a, useClient as u };
